// import { DatePipe } from '@angular/common';
import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDatepicker, MatDatepickerInputEvent, MatSidenav } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import moment, { Moment } from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExcelService } from '../../scrumboard/excel.service';
import Highcharts from 'highcharts';
import HighchartsExporting from 'highcharts/modules/exporting';

HighchartsExporting(Highcharts);

// Date picker format
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-check-in-out-report',
  templateUrl: './check-in-out-report.component.html',
  styleUrls: ['./check-in-out-report.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})

export class CheckInOutReportComponent implements OnInit {

  @Input() max: any;
  tomorrow = new Date();
  date = new FormControl(moment());
  checkInOutDetails1: any = [];
  checkTotalCountWeek: number = 0;
  copyCheckInOutDetailsWeek: any = [];
  sortNameList: any = [];
  monthWorkHoursList: any = [];
  monthBreakHoursList: any = [];
  highcharts = Highcharts;
  chartOptions: any;
  isShowChart: boolean = false;
  isMetricsButton: Boolean = true;

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  async chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    this.selectedDesignation = ['all'];
    const m: Moment = ctrlValue;
    if (m) {
      var month = m.format('M');
      var year = m.format('YYYY');
      this.generateDynamicColumn(Number(month) - 1);

      if (Number(month) < 10) { month = `0${month}` }
      await this.checkInOutReport(`${year}-${month}`);
    }
    datepicker.close();
  }

  firstname: string = '';
  lastname: string = '';
  empRole: string = '';
  tenantId: string = '';
  checkTotalCount: number = 0;
  checkInOutDetails: any = [];
  particularCheckInInfo: any = [];
  checkInfo: any = [];
  reportType: string = 'Month';
  @ViewChild('drawer', { static: false }) drawer: MatSidenav;

  month: Array<number> = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  checkInOutCol: Array<object> = [];
  checkInOutCol1: Array<object> = [{ field: 'position', header: 'S.No' },
  { field: 'image', header: 'Profile' },
  { field: 'name', header: 'Name' },
  { field: 'role', header: 'Designation' },
  { field: 'totalMonthWorkHours', header: 'Total Work Hour' },
  { field: 'totalMonthBreakHours', header: 'Total Break Hour' },
  { field: 'week1', header: 'Week 1' },
  { field: 'week2', header: 'Week 2' },
  { field: 'week3', header: 'Week 3' },
  { field: 'week4', header: 'Week 4' },
  { field: 'week5', header: 'Week 5' },
  ];

  checkInOut: Array<object> = [
    { field: 'position', header: 'S.No' },
    { field: 'date', header: 'Date' },
    { field: 'totalWorkHours', header: 'Work Hour' },
    { field: 'totalBreakHours', header: 'Break Hour' }
  ]
  currentPosition: number = 0;
  selectedDesignation: any = ['all'];
  rollOptions: any = [];
  roleDD = [];
  copyCheckInOutDetails: any = [];
  isShowNextButton: boolean = true;

  constructor(
    private parseService: ParseService,
    private storageConfiguration: StorageConfiguration,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private queryInterface: QueryInterface,
    private excelService: ExcelService
  ) {
    this.firstname = this.parseService.instance.User.current().get('firstName');
    this.lastname = this.parseService.instance.User.current().get('lastName');
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);

    this.tomorrow.setDate(this.tomorrow.getDate() + 1);
  }

  ngOnInit() {
    this.checkInOutReport();
    this.getDesignations();
  }

  getDesignations() {
    let result = [];
    this.queryInterface.queryRoleAll(this.parseService).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let roleList = JSON.parse(jsonText);
        if (roleList.displayName) {
          result.push({ name: roleList.displayName, id: roleList.role.objectId });
        }
        else {
          result.push({ name: roleList.name, id: roleList.objectId });
        }
      }
      this.roleDD = result;
      this.rollOptions = this.bindDropDown(this.roleDD);
    });
  }

  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.name, value: a.id });
    });
    return dropDownItem;
  }

  checkInOutReport(selectDate?: string) {
    this.spinner.show();
    this.isShowNextButton = true;
    if (selectDate) {
      var selectedMonth: any = selectDate;
    }
    else {
      const date = new Date();
      let month: any = date.getMonth() + 1;
      this.generateDynamicColumn(date.getMonth());
      if (month < 10) { month = `0${month}` }
      var selectedMonth: any = `${date.getFullYear()}-${month}`;
    }

    let queryInstance = this.parseService.instance.Object.extend('checkIncheckOutReport');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('month', selectedMonth);
    query.include('profile');
    query.include('profile.role');
    query.include('profile.reportingTo');
    query.equalTo('tenantId', this.tenantId);
    query.limit(1000);
    query.withCount();
    query.find().then(result => {
      this.checkTotalCount = 0;
      this.checkTotalCountWeek = 0;
      this.checkInOutDetails1 = [];
      this.checkInOutDetails = [];
      if (result.results.length > 0) {
        let i = 0;
        this.checkTotalCount = result.count;
        this.checkTotalCountWeek = result.count;
        for (let res of result.results) {
          if (this.reportType == 'Week') {
            i = i + 1;
            if (Object.keys(res.get('profile').get('profileImageInfo')).length > 0) { var profileImage = res.get('profile').get('profileImageInfo').url }
            else { var profileImage: any = ''; }
            let details: any = this.groupDataByWeeks(res.get('checkInOutDetails'));

            let info = {
              position: i,
              id: res.id,
              image: profileImage,
              checkInOutInfo: res.get('checkInOutDetails'),
              name: res.get('profile').get('username'),
              email: res.get('profile').get('email'),
              role: res.get('profile').get('role').get('name'),
              reporting: res.get('profile').get('reportingTo').get('username'),
              checkInOutLog: res.get('checkInOutDetails'),
              checkInOutId: res.get('checkInOutDetails')[0].InOut[0].esslUserId,
              week1: details.firstWeek ? this.convertMinutesToTime(details.firstWeek.totalWorkHours) : '--',
              week2: details.secondWeek ? this.convertMinutesToTime(details.secondWeek.totalWorkHours) : '--',
              week3: details.thirdWeek ? this.convertMinutesToTime(details.thirdWeek.totalWorkHours) : '--',
              week4: details.fourthWeek ? this.convertMinutesToTime(details.fourthWeek.totalWorkHours) : '--',
              week5: details.fifthWeek ? this.convertMinutesToTime(details.fifthWeek.totalWorkHours) : '--',
              sortWorkHour: res.get('monthTotalWorkHours').replace(':', '.'),
              totalMonthWorkHours: res.get('monthTotalWorkHours'),
              totalMonthBreakHours: res.get('monthTotalBreakHours')

            };
            this.checkInOutDetails1.push(info);
          }
          else if (this.reportType == 'Month') {
            i = i + 1;
            if (Object.keys(res.get('profile').get('profileImageInfo')).length > 0) { var profileImage = res.get('profile').get('profileImageInfo').url }
            else { var profileImage: any = ''; }
            let info = {
              position: i,
              id: res.id,
              image: profileImage,
              checkInOutInfo: res.get('checkInOutDetails'),
              name: res.get('profile').get('username'),
              email: res.get('profile').get('email'),
              role: res.get('profile').get('role').get('name'),
              reporting: res.get('profile').get('reportingTo').get('username'),
              totalMonthWorkHours: res.get('monthTotalWorkHours'),
              totalMonthBreakHours: res.get('monthTotalBreakHours'),
              checkInOutLog: res.get('checkInOutDetails'),
              sortWorkHour: res.get('monthTotalWorkHours').replace(':', '.'),
              checkInOutId: res.get('checkInOutDetails')[0].InOut[0].esslUserId,
            };

            const information = res.get('checkInOutDetails').reverse();
            if (information.length > 0) {
              for (let inf of information) {
                var outTime = new Date(inf.date).getTime();
                var convertIstTimeFormat = new Date(outTime);
                convertIstTimeFormat.setHours(convertIstTimeFormat.getHours() - 5);
                convertIstTimeFormat.setMinutes(convertIstTimeFormat.getMinutes() - 30);
                let date = this.datePipe.transform(convertIstTimeFormat, "MMM d")
                info[`${date}`] = inf.totalWorkHours;
              }
            }
            this.checkInOutDetails.push(info);
          }
        }

        if (this.reportType == 'Month') {
          this.checkInOutDetails = this.checkInOutDetails.sort((a, b) => { return b.sortWorkHour - a.sortWorkHour });
          let j = 0;
          this.checkInOutDetails.map(x => { j = j + 1; x.position = j; });
          this.copyCheckInOutDetails = this.checkInOutDetails;
        }
        else {
          this.checkInOutDetails1 = this.checkInOutDetails1.sort((a, b) => { return b.sortWorkHour - a.sortWorkHour });
          let j = 0;
          this.checkInOutDetails1.map(x => { j = j + 1; x.position = j; });
          this.copyCheckInOutDetailsWeek = this.checkInOutDetails1;
        }
        if (this.isShowChart) this.getMonthMetricsInfo();
        this.spinner.hide();
      }
      else {
        this.checkInOutDetails = [];
        this.copyCheckInOutDetails = []; ``
        this.copyCheckInOutDetailsWeek = [];
        this.spinner.hide();
      }
    });
  }

  convertMinutesToTime(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    return `${formattedHours}:${formattedMinutes}`;
  }

  generateDynamicColumn(month: any) {
    var result = [];
    this.checkInOutCol = [];

    this.checkInOutCol.push({ field: 'position', header: 'S.No' },
      { field: 'image', header: 'Profile' },
      { field: 'name', header: 'Name' },
      { field: 'role', header: 'Designation' },
      { field: 'totalMonthWorkHours', header: 'Total Work Hour' },
      { field: 'totalMonthBreakHours', header: 'Total Break Hour' }
    )

    for (var i = 0; i < 7; i++) {
      var d = new Date();
      d.setMonth(month);
      if (month == new Date().getMonth()) { d.setDate(d.getDate() - i); }
      else {
        d.setDate(this.month[month] - i);
      }
      result.push(d);
      this.checkInOutCol.push({ field: this.datePipe.transform(d, "MMM d"), header: this.datePipe.transform(d, "MMM d") })
    }
  }


  getEmployeeCheckInOutDetails(id?: any) {
    if (id == 'next') {
      if (id != 'next') {
        var position = id; this.currentPosition = id;
      }
      else {
        var position: any = this.currentPosition + 1;
        this.currentPosition = position;
      }

      if (this.checkTotalCount < this.currentPosition) {
        return this.currentPosition = this.checkTotalCount;
      }
    }
    this.filterCheckInOutInfo(position ? position : id);
  }

  getPreviousInfo() {
    if (this.currentPosition != 1) {
      var position = this.currentPosition - 1;
      this.currentPosition = position;
      this.filterCheckInOutInfo(position);
    }
    else {
      return this.currentPosition = 1;
    }
  }

  filterCheckInOutInfo(position) {
    this.particularCheckInInfo = this.checkInOutDetails.filter(x => x.position === position);
    let j = 0;
    this.checkInfo = [];
    for (let data of this.particularCheckInInfo[0].checkInOutLog) {
      j = j + 1;
      var outTime = new Date(data.date).getTime();
      var convertIstTimeFormat = new Date(outTime);
      convertIstTimeFormat.setHours(convertIstTimeFormat.getHours() - 5);
      convertIstTimeFormat.setMinutes(convertIstTimeFormat.getMinutes() - 30);
      let date = this.datePipe.transform(convertIstTimeFormat, "MMM d, y")

      this.checkInfo.push({
        position: j,
        date: date,
        totalWorkHours: data.totalWorkHours,
        totalBreakHours: data.totalBreakHours
      });
    }
  }

  closeDrawer() {
    this.drawer.close();
  }

  handleMissingImage(event) {
    this.particularCheckInInfo[0].image = 'assets/images/avatars/profile.jpg';
  }

  async chooseTeam() {


    if (this.reportType == 'Month') {
      if (this.selectedDesignation[0] != 'all' && this.selectedDesignation.length > 0) {
        this.isShowNextButton = false;
        this.checkInOutDetails = this.copyCheckInOutDetails
        this.checkInOutDetails = await this.checkInOutDetails.filter(x => this.selectedDesignation.includes(x.role));
        this.checkInOutDetails = this.checkInOutDetails.sort((a, b) => { return b.sortWorkHour - a.sortWorkHour });
        this.checkTotalCount = this.checkInOutDetails.length;
      }
      else if (this.selectedDesignation[0] == 'all' || this.selectedDesignation.length == 0) {
        this.isShowNextButton = true;
        this.checkInOutDetails = this.copyCheckInOutDetails;
        this.checkInOutDetails = this.checkInOutDetails.sort((a, b) => { return b.sortWorkHour - a.sortWorkHour });
        this.checkTotalCount = this.checkInOutDetails.length;
      }
      if (this.isShowChart) this.getMonthMetricsInfo();
    }
    else if (this.reportType == 'Week') {
      if (this.selectedDesignation[0] != 'all' && this.selectedDesignation.length > 0) {
        this.checkInOutDetails1 = this.copyCheckInOutDetailsWeek
        this.checkInOutDetails1 = await this.checkInOutDetails1.filter(x => this.selectedDesignation.includes(x.role));
        this.checkInOutDetails1 = this.checkInOutDetails1.sort((a, b) => { return b.sortWorkHour - a.sortWorkHour });
        this.checkTotalCountWeek = this.checkInOutDetails1.length;
      }
      else if (this.selectedDesignation[0] == 'all' || this.selectedDesignation.length == 0) {
        this.checkInOutDetails1 = this.copyCheckInOutDetailsWeek;
        this.checkInOutDetails1 = this.checkInOutDetails1.sort((a, b) => { return b.sortWorkHour - a.sortWorkHour });
        this.checkTotalCountWeek = this.checkInOutDetails1.length;
      }
      if (this.isShowChart) this.getWeekMetricsInfo();
    }
  }

  chooseReportType(event) {
    this.reportType = event.value;
    this.checkInOutReport();
  }

  // Method to group data by weeks
  groupDataByWeeks(data) {
    const groupedData = {};
    data.forEach((item) => {
      const date = new Date(item.date);
      const weekLabel = this.getWeekLabel(date);
      if (!groupedData[weekLabel]) {
        groupedData[weekLabel] = {
          totalWorkHours: 0,
        };
      }
      // Check if totalWorkHours is a valid time format (hh:mm) before adding
      if (this.isValidTimeFormat(item.totalWorkHours)) {
        const [hours, minutes] = item.totalWorkHours.split(':');
        const totalHoursInMinutes = parseInt(hours) * 60 + parseInt(minutes);
        groupedData[weekLabel].totalWorkHours += totalHoursInMinutes;
      }
    });
    return groupedData;
  }

  isValidTimeFormat(time) {
    // Regular expression to validate hh:mm format
    const timePattern = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
    return timePattern.test(time);
  }

  getWeekLabel(date) {
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const currentDate = date.getDate();
    const weekNumber = Math.ceil((currentDate + startOfMonth.getDay()) / 7);
    switch (weekNumber) {
      case 1:
        return "firstWeek";
      case 2:
        return "secondWeek";
      case 3:
        return "thirdWeek";
      case 4:
        return "fourthWeek";
      default:
        return "fifthWeek";
    }
  }

  exportToExcel() {
    let info = this.checkInOutDetails;
    info.map(x => {
      delete x.id;
      delete x.image;
      delete x.position;
      delete x.checkInOutInfo;
      delete x.sortWorkHour;
      delete x.checkInOutLog;
    })
    this.excelService.exportAsExcelFile(info, 'Employees month Check-In/Out report ');
  }

  exportToExcelWeek() {
    let info = this.checkInOutDetails1;
    info.map(x => {
      delete x.id;
      delete x.image;
      delete x.position;
      delete x.checkInOutInfo;
      delete x.sortWorkHour;
      delete x.checkInOutLog;
    })
    this.excelService.exportAsExcelFile(info, 'Employees week Check-In/Out report ');
  }


  getMonthMetricsInfo() {
    if (this.reportType == "Month") {
      this.sortNameList = [];
      this.monthWorkHoursList = [];
      this.monthBreakHoursList = [];

      let info = this.checkInOutDetails.sort((a, b) => { return a.sortWorkHour - b.sortWorkHour });
      info.map(x => {
        this.sortNameList.push(`${x.name} ( ${x.totalMonthWorkHours} ) Hrs`);
        this.monthWorkHoursList.push(Number(x.totalMonthWorkHours.replace(':', '.')));
        this.monthBreakHoursList.push(Number(x.totalMonthBreakHours.replace(':', '.')));
      })

      this.chartOptions = {
        chart: {
          type: 'bar',
          height: 1000,
          width: 1450,
        },
        title: {
          text: `Monthly Analytics`,
          color: '#2C3460'
        },
        xAxis: {
          categories: this.sortNameList
        },
        yAxis: {
          title: {
            text: "Monthly basis",
            color: '#2C3460'
          }
        },
        exporting: {
          enabled: true, // Enable exporting
          buttons: {
            contextButton: {
              menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG'],
            },
            typeOptions: {
              "image/jpeg": {
                filename: 'my-chart', // Specify the filename
                width: 1600,
                height: 1800,
                scale: 1, // Set scale to 1 for full resolution (optional)
                quality: 1, // Set maximum quality (optional)
              },
            }
          }
        },
        tooltip: {
          valueSuffix: " "
        },
        series: [{
          name: 'Monthly Work Hours',
          data: this.monthWorkHoursList
        }, {
          name: 'Monthly Break Hours',
          data: this.monthBreakHoursList
        }],
        colors: ['#3EB645E3', '#FF8181'],
      };
    }
    else if (this.reportType == "Week") {
      this.getWeekMetricsInfo()
    }
  }

  async getWeekMetricsInfo() {
    let sortNameList = [];
    let week1 = [];
    let week2 = [];
    let week3 = [];
    let week4 = [];
    let week5 = [];

    let isWeek1 = false;
    let isWeek2 = false;
    let isWeek3 = false;
    let isWeek4 = false;
    let isWeek5 = false;

    let info = this.checkInOutDetails1;

    info.map(x => {
      x.week1 = Number(x.week1 == "--" ? 0 : typeof (x.week1) == "string" ? x.week1.replace(':', '.') : x.week1);
      x.week2 = Number(x.week2 == "--" ? 0 : typeof (x.week2) == "string" ? x.week2.replace(':', '.') : x.week2);
      x.week3 = Number(x.week3 == "--" ? 0 : typeof (x.week3) == "string" ? x.week3.replace(':', '.') : x.week3);
      x.week4 = Number(x.week4 == "--" ? 0 : typeof (x.week4) == "string" ? x.week4.replace(':', '.') : x.week4);
      x.week5 = Number(x.week5 == "--" ? 0 : typeof (x.week5) == "string" ? x.week5.replace(':', '.') : x.week5);
    })

    let currentWeek = await this.getCurrentWeekOfMonth();
    switch (currentWeek) {
      case 1:
        isWeek1 = true;
        info = info.sort((a, b) => { return a.week1 - b.week1 });
        break;
      case 2: isWeek2 = true;
        info = info.sort((a, b) => { return a.week2 - b.week2 });
        break;
      case 3: isWeek3 = true;
        info = info.sort((a, b) => { return a.week3 - b.week3 });
        break;
      case 4: isWeek4 = true;
        info = info.sort((a, b) => { return a.week4 - b.week4 });
        break;
      case 5: isWeek5 = true;
        info = info.sort((a, b) => { return a.week5 - b.week5 });
        break;
      default: break;
    }

    info.map(x => {
      sortNameList.push(`${x.name} ( ${isWeek1 ? x.week1 : isWeek2 ? x.week2 : isWeek3 ? x.week3 : isWeek4 ? x.week4 : isWeek5 ? x.week5 : x.totalMonthWorkHours} ) Hrs`);
      week1.push(x.week1);
      week2.push(x.week2);
      week3.push(x.week3);
      week4.push(x.week4);
      week5.push(x.week5);
    })

    this.chartOptions = {
      chart: {
        type: 'bar',
        height: 1000,
        width: 1450,
      },
      title: {
        text: "Weekly Analytics",
        color: '#2C3460'
      },
      xAxis: {
        categories: sortNameList
      },
      yAxis: {
        title: {
          text: "Weekly basis",
          color: '#2C3460'
        }
      },
      exporting: {
        enabled: true, // Enable exporting
        buttons: {
          contextButton: {
            menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG'],
          },
          typeOptions: {
            "image/jpeg": {
              filename: 'my-chart', // Specify the filename
              width: 1600,
              height: 1800,
              scale: 1, // Set scale to 1 for full resolution (optional)
              quality: 1, // Set maximum quality (optional)
            },
          }
        }
      },
      tooltip: {
        valueSuffix: " "
      },
      series: [{
        name: '1st Week',
        data: week1,
        visible: isWeek1,
        events: {
          legendItemClick: function (event) {
            if (info && info.length > 0) {
              let wee1Info = info;
              wee1Info.map(x => { x.week1 = Number(x.week1 == "--" ? 0 : typeof (x.week1) == "string" ? x.week1.replace(':', '.') : x.week1); })
              wee1Info.sort((a, b) => { return a.week1 - b.week1; });
              week1.length = 0;
              week2.length = 0;
              week3.length = 0;
              week4.length = 0;
              week5.length = 0;
              sortNameList.length = 0;
              wee1Info.forEach(x => {
                sortNameList.push(`${x.name} ( ${x.week1} ) Hrs`);
                week1.push(x.week1);
                week2.push(x.week2);
                week3.push(x.week3);
                week4.push(x.week4);
                week5.push(x.week5);
              });

              // Update xAxis categories
              this.chart.xAxis[0].update({ categories: sortNameList }, true);
              // Update data for all series
              this.chart.series[0].setData(week1);
              this.chart.series[1].setData(week2);
              this.chart.series[2].setData(week3);
              this.chart.series[3].setData(week4);
              this.chart.series[4].setData(week5);
            }

            this.chart.redraw();
          },
        },
      }, {
        name: '2nd Week',
        data: week2,
        visible: isWeek2,
        events: {
          legendItemClick: function (event) {
            if (info && info.length > 0) {
              let wee1Info = info;
              wee1Info.map(x => { x.week2 = Number(x.week2 == "--" ? 0 : typeof (x.week2) == "string" ? x.week2.replace(':', '.') : x.week2); })
              wee1Info.sort((a, b) => { return a.week2 - b.week2 });
              week1.length = 0;
              week2.length = 0;
              week3.length = 0;
              week4.length = 0;
              week5.length = 0;
              sortNameList.length = 0;

              wee1Info.forEach(x => {
                sortNameList.push(`${x.name} ( ${x.week2} ) Hrs`);
                week1.push(x.week1);
                week2.push(x.week2);
                week3.push(x.week3);
                week4.push(x.week4);
                week5.push(x.week5);
              });

              // Update xAxis categories
              this.chart.xAxis[0].update({ categories: sortNameList }, true);

              // Update data for all series
              this.chart.series[0].setData(week1);
              this.chart.series[1].setData(week2);
              this.chart.series[2].setData(week3);
              this.chart.series[3].setData(week4);
              this.chart.series[4].setData(week5);
            }

            this.chart.redraw();
          },
        },
      }, {
        name: '3rd Week',
        data: week3,
        visible: isWeek3,
        events: {
          legendItemClick: function (event) {
            if (info && info.length > 0) {
              let wee1Info = info;
              wee1Info.map(x => { x.week3 = Number(x.week3 == "--" ? 0 : typeof (x.week3) == "string" ? x.week3.replace(':', '.') : x.week3); })
              wee1Info.sort((a, b) => { return a.week3 - b.week3 });
              week1.length = 0;
              week2.length = 0;
              week3.length = 0;
              week4.length = 0;
              week5.length = 0;
              sortNameList.length = 0;
              wee1Info.forEach(x => {
                sortNameList.push(`${x.name} ( ${x.week3} ) Hrs`);
                week1.push(x.week1);
                week2.push(x.week2);
                week3.push(x.week3);
                week4.push(x.week4);
                week5.push(x.week5);
              });
              // Update xAxis categories
              this.chart.xAxis[0].update({ categories: sortNameList }, true);

              // Update data for all series
              this.chart.series[0].setData(week1);
              this.chart.series[1].setData(week2);
              this.chart.series[2].setData(week3);
              this.chart.series[3].setData(week4);
              this.chart.series[4].setData(week5);
            }
            this.chart.redraw();
          },
        },
      }, {
        name: '4th Week',
        data: week4,
        visible: isWeek4,
        events: {
          legendItemClick: function (event) {
            if (info && info.length > 0) {
              let wee1Info = info;
              wee1Info.map(x => { x.week4 = Number(x.week4 == "--" ? 0 : typeof (x.week4) == "string" ? x.week4.replace(':', '.') : x.week4); })
              wee1Info.sort((a, b) => { return a.week4 - b.week4 });
              week1.length = 0;
              week2.length = 0;
              week3.length = 0;
              week4.length = 0;
              week5.length = 0;
              sortNameList.length = 0;
              wee1Info.forEach(x => {
                sortNameList.push(`${x.name} ( ${x.week4} ) Hrs`)
                week1.push(x.week1);
                week2.push(x.week2);
                week3.push(x.week3);
                week4.push(x.week4);
                week5.push(x.week5);
              });
              // Update xAxis categories
              this.chart.xAxis[0].update({ categories: sortNameList }, true);

              // Update data for all series
              this.chart.series[0].setData(week1);
              this.chart.series[1].setData(week2);
              this.chart.series[2].setData(week3);
              this.chart.series[3].setData(week4);
              this.chart.series[4].setData(week5);
            }
            this.chart.redraw();
          },
        },
      }, {
        name: '5th Week',
        data: week5,
        visible: isWeek5,
        events: {
          legendItemClick: function (event) {
            if (info && info.length > 0) {
              let wee1Info = info;
              wee1Info.map(x => { x.week5 = Number(x.week5 == "--" ? 0 : typeof (x.week5) == "string" ? x.week5.replace(':', '.') : x.week5); })
              wee1Info.sort((a, b) => { return a.week5 - b.week5 });
              week1.length = 0;
              week2.length = 0;
              week3.length = 0;
              week4.length = 0;
              week5.length = 0;
              sortNameList.length = 0;
              wee1Info.forEach(x => {
                sortNameList.push(`${x.name} ( ${x.week5} ) Hrs`);
                week1.push(x.week1);
                week2.push(x.week2);
                week3.push(x.week3);
                week4.push(x.week4);
                week5.push(x.week5);
              });

              // Update xAxis categories
              this.chart.xAxis[0].update({ categories: sortNameList }, true);

              // Update data for all series
              this.chart.series[0].setData(week1);
              this.chart.series[1].setData(week2);
              this.chart.series[2].setData(week3);
              this.chart.series[3].setData(week4);
              this.chart.series[4].setData(week5);
            }
            this.chart.redraw();
          },
        },
      }],
      colors: ['#EEA463', '#FF8181', '#FFBF00', '#6495ED', '#3EB645E3'],
    };
  }

  getCurrentWeekOfMonth() {
    const currentDate = new Date();
    const currentDay = currentDate.getDate(); // Get the day of the month
    const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); // First day of the current month
    const dayOfWeekOfFirstDay = startOfMonth.getDay(); // Get the day of the week (0 = Sunday, 1 = Monday, ...)
    // Calculate the current week of the month
    const currentWeekOfMonth = Math.ceil((currentDay + dayOfWeekOfFirstDay) / 7);
    return currentWeekOfMonth;
  }

  downloadChart() {
    const chart: any = Highcharts.charts[0]; // Get a reference to your chart
    if (chart) {
      // Set the width and height in the chart options
      chart.update({
        chart: {
          width: 800, // Adjust width as needed
          height: 600, // Adjust height as needed
        },
      });

      // Export the chart as a JPEG with specified quality
      chart.exportChart({
        type: 'image/jpeg', // Specify the format (JPEG)
        filename: 'my-chart', // Specify the filename
        quality: 0.8, // Adjust quality (0.8 means 80% quality)
      });
    }
  }


}
